export default {
    showing: "Showing",
    of: "of"
}
